// extracted by mini-css-extract-plugin
module.exports = {"postBody":"post-body_postBody_3mT"};